import type { StaffDetail } from "@/api/guide";
import { THEME } from "../constants";

interface TagRowProps {
  guide: StaffDetail;
}

export default function TagRow({ guide }: TagRowProps) {
  return (
    <div className="mx-4 mt-16 flex flex-wrap items-center gap-2">
      {/* 接单状态标签 */}
      <span
        className="flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium"
        style={{
          color: guide.workStatus === 1 ? THEME.success : THEME.textSecondary,
          background: guide.workStatus === 1 ? `${THEME.success}15` : "rgba(255,255,255,0.04)",
          border: `1px solid ${guide.workStatus === 1 ? `${THEME.success}30` : "rgba(255,255,255,0.08)"}`,
        }}
      >
        <span className="w-1.5 h-1.5 rounded-full inline-block" style={{ background: guide.workStatus === 1 ? THEME.success : THEME.textSecondary }} />
        {guide.workStatus === 1 ? "接单中" : "暂不接单"}
      </span>

      {/* 评分标签 */}
      <span className="flex items-center gap-1 px-2.5 py-1 rounded-full text-xs" style={{ color: THEME.star, border: `1px solid ${THEME.star}30`, background: `${THEME.star}11` }}>
        <i className="ri-star-fill" style={{ fontSize: 11 }} />{guide.score} 分
      </span>

      {/* 认证标签 */}
      {guide.certifications.map((cert, idx) => (
        <span key={idx} className="flex items-center gap-1 px-2.5 py-1 rounded-full text-xs" style={{ color: THEME.primary, border: `1px solid ${THEME.primaryBorder}`, background: `${THEME.primary}11` }}>
          <i className="ri-shield-check-fill" style={{ fontSize: 12 }} />{cert}
        </span>
      ))}

      {/* 健康证标签 */}
      {guide.healthTag && (
        <span className="flex items-center gap-1 px-2.5 py-1 rounded-full text-xs" style={{ color: THEME.success, border: `1px solid ${THEME.success}33`, background: `${THEME.success}11` }}>
          <i className="ri-heart-pulse-line" style={{ fontSize: 12 }} />{guide.healthTag}
        </span>
      )}
    </div>
  );
}
